import React from "react";
import ArrowIcon from "../../shared/arrow";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

import styles from "./styles.css";
import Accordion from "../../shared/accordion";
import { ANGLE } from "../../../constants/app-constants";
import H2Blue from "../h2-bule/component";

const normalizeCmsText = (text = "") => {
    return text
        .replace(/\\\\/g, "\\")
        .replace(/\\n/g, "\n");
};

const CarDetailsFaq = ({faqRef, faqCdpRevamp, faqData}) => {
    const ALLFAQ = (faqData || []).map((item) => ({
        ...item,
        description: normalizeCmsText(item.description),
        text2: normalizeCmsText(item.text2)
    }));
    const trackEvent = () => {

    };

    const faqSchema = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": (ALLFAQ || []).map(({ title, description, text2 }) => {
            const answerParts = [description, text2].filter(Boolean);
            return {
                "@type": "Question",
                "name": title,
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": answerParts.join(" ")
                }
            };
        })
    });

    return (
        <div className="container" styleName="styles.wrapper">
            <Helmet script={[{
                type: "application/ld+json",
                innerHTML: faqSchema
            }]}
            />
            <div styleName={"styles.headingWrapper"}>
                {faqCdpRevamp ? <h3>Frequently Asked Questions</h3> : <H2Blue text="Frequently Asked Questions" />}
            </div>
            <div className="row" ref={faqRef}>
                <div className="col-12" >
                    {ALLFAQ.map((item, index) =>
                        (
                            <Accordion  key={index} toggleAll={true} totalItems={ALLFAQ.length} collapseAccordion={true}>
                                {({ onClick, currentVisibleStates }) => (
                                    <div styleName={"styles.questionWrapper"}  onClick={() => {
                                        onClick({index});
                                    }}>
                                        <Accordion.Content>
                                            <Accordion.Heading>
                                                <div onClick={() => currentVisibleStates[index] && trackEvent(index, currentVisibleStates[index])} styleName={"styles.questionContainer"}>
                                                    <p styleName={"styles.question"}>{item.title}</p>
                                                    <ArrowIcon black={"BlackArrow"} rotateBy={currentVisibleStates[index] ?  0 : -ANGLE.HUNDRED_EIGHTY } />
                                                </div>
                                            </Accordion.Heading>
                                            <Accordion.Body>
                                                {!currentVisibleStates[index] &&
                                            <p styleName={"styles.answer"}>
                                                {item.description}
                                                {item.linkText &&  <a href={item.link} target="_blank">{item.linkText}</a>}
                                                {item.text2 || ""}
                                            </p>
                                                }
                                            </Accordion.Body>
                                        </Accordion.Content>
                                    </div>
                                )}

                            </Accordion>)
                    )}
                </div>
            </div>
        </div>
    );
};

CarDetailsFaq.propTypes = {
    faqRef: PropTypes.object,
    faqCdpRevamp: PropTypes.bool,
    faqData: PropTypes.object
};

export default CarDetailsFaq;
